import Homepage from './homepage';
export { Homepage };

import JobPage from './jobpage';
export { JobPage };

import IndexPage from './indexpage';
export { IndexPage };

import PavilionPage from './pavilionpage';
export { PavilionPage };

import ActivityPage from './activitypage';
export { ActivityPage }

import EventsPage from './eventspage';
export { EventsPage }


// WEBPACK FOOTER //
// ./src/modules/pages/index.js